/**
 * 百度网盟广告
 */
export default {
  /**
   * 待执行队列
   */
  _waitQueue: [],
  /**
   * 加载百度网盟广告
   * @param params
   */
  getAdsList (params) {
    this._waitQueue.push(arguments); // 先进入待执行队列，如果本次没有初始化完成，则下次一起操作
    if (window.hasOwnProperty('BAIDU_CLB_fillSlotAsync')) {
      while(this._waitQueue.length > 0) {
        let bdParam = this._waitQueue.pop();
        BAIDU_CLB_fillSlotAsync(bdParam[0].uid, bdParam[0].divId);
        setTimeout (() => { bdParam[1] && bdParam[1](); }, 300);
      }
    }
  }
}
